<template>
  <b-nav class="main-nav">
    <b-nav-item class="logo" href="/">
      <img src="../assets/img/logo.png"/>
    </b-nav-item>
    <div class="main-div">
      <div class="login-div">
          <p>Thank you for registering with us. We have sent you an email on
             {{email}}. Please follow the link in email to activate your account.</p>
      </div>
    </div>
  </b-nav>
</template>

<script>

export default {
  name: 'Confirmation',
  data() {
    const confirmEmail = this.$route.query.email;
    return {
      email: confirmEmail,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo {
  margin-top: 20px;
  width: 80%;
  margin-left: 30px;
}
.main-nav {
  background-color: #2c3e50 !important;
  height: 90px;
}
.main-div {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  margin: auto;
}

.login-div {
  background-color: white;
  width: 60%;
  height: 260px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/confirmation.vue